<template>
  <EmailGrabberPopup
    @close="toggleGrabber"
    :grabberActive="grabberActive"
    :freePlan="freePlan"
    :payPlan="payPlan"
    :planId="planId"
    class="overflow-y-hidden"
  >
  </EmailGrabberPopup>
  <!-- ===================== CTA BLOCK ===================== -->
  <div
    class="protect-cta-block relative mx-[25px] mt-[75px] h-auto w-auto overflow-hidden rounded-[10px] bg-white bg-[bottom_-25px_right_-120px] bg-no-repeat px-5 py-[35px] drop-shadow-2xl lg:flex lg:bg-[length:275px] lg:bg-[center_left_-115px] lg:px-[46px] lgpl-[200px] xl:pl-[225px] xl:mx-auto xl:mt-[150px] xl:h-[180px] xl:w-[1200px]"
  >
    <div class="my-auto bg-transparent lg:max-w-[735px]">
      <h2
        class="mx-auto bg-transparent text-[35px] font-extrabold leading-[48px] tracking-[.42px] text-[#292d34] lg:text-[50px]"
      >
        Protect and Monetize.
      </h2>

      <p
        class="mt-[10px] max-w-[230px] bg-transparent text-sm font-medium leading-[25px] text-[#292d34] lg:max-w-[440px]"
      >
        All of your content and digital products in one place to sell.
      </p>
    </div>

    <div class="mr-auto mt-[30px] w-[170px] sm:my-auto sm:mt-[30px] lg:ml-auto">
      <button
        @click="toggleGrabber('free', null)"
        type="button"
        class="h-[56px] w-[170px] rounded-[9px] bg-[#2d8bff] text-[14px] text-base font-bold text-white drop-shadow-[0px_10px_25px_#64A7F9] transition ease-in hover:bg-[#0f61c5] active:bg-[#054ca3] dark:border-none"
      >
        Free Forever
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import EmailGrabberPopup from '../Components/EmailGrabberPopup.vue';

const grabberActive = ref(false);
const freePlan = ref(false);
const payPlan = ref(false);
const planId = ref(null);

const props = defineProps({
  ctaHeadline: {
    type: String,
    required: false
  }
});

const toggleGrabber = (plan, id) => {
  if (plan === 'free') {
    freePlan.value = true;
    payPlan.value = false;
    planId.value = null;
  }
  if (plan === 'pay') {
    payPlan.value = true;
    planId.value = id;
    freePlan.value = false;
  }
  grabberActive.value = !grabberActive.value;
};
</script>

<style scoped>
.protect-cta-block {
  background-image: url(../media/images/platforma-logo-stacked.svg);
  background-size: auto;
}
</style>
